<template>
  <div class="exam">
    <Loading :active.sync="processing" :can-cancel="false" />

    <section v-if="exam.is_allowed" class="container">
      <div v-if="exam.is_queued">
        <Intro :exam="exam" @begin="begin" />
      </div>

      <div v-if="exam.is_in_progress">
        <div class="columns">
          <div class="column is-12 is-right">
            <div class="count-down" v-html="countDown" />
          </div>
        </div>
        <Questionnaire :exam="exam" @complete="complete" @answered="answer" />
      </div>
    </section>

    <GracePeriod :exam="exam" />

    <Succeeded :exam="exam" />

    <Failed :exam="exam" />
  </div>
</template>

<script>
import { find, map } from 'lodash';
import api from 'api/exam';
import moment from 'moment';
import Intro from './Intro';
import Questionnaire from './Questionnaire';
import GracePeriod from './GracePeriod';
import Succeeded from './Succeeded';
import Failed from './Failed';

export default {
  name: 'Exam',

  components: {
    Intro,
    Questionnaire,
    GracePeriod,
    Succeeded,
    Failed
  },

  props: {
    exam_data: { type: Object, required: true }
  },

  data() {
    return {
      countDownInterval: null,
      countDown: null,
      processing: false,
      exam: this.exam_data.data
    };
  },

  watch: {
    'exam.end_time': {
      handler() {
        this.setCountDown();
      },
      deep: true
    }
  },

  mounted() {
    this.setCountDown();
  },

  methods: {
    begin() {
      this.processing = true;
      api
        .begin(this.exam.id, this.exam.course_id)
        .then(data => {
          this.exam = data;
          this.processing = false;
        })
        .catch(e => {
          error(e.message);
          this.processing = false;
        });
    },

    answer(q) {
      if (q.answered && q.student_answer) {
        api
          .answer(q.id, q.student_answer, this.exam.id, this.exam.course_id)
          .then(data => {
            this.exam = data;

            q = find(this.exam.questions, _q => _q.id === q.id);
            q.selected = true;

            flash(this.$t('exam.answer-accepted'));
          })
          .catch(e => {
            error(e.message);
          });
      }
    },

    complete() {
      if (this.exam.is_in_progress) {
        this.processing = true;

        api
          .complete(
            this.exam.id,
            this.exam.course_id,
            map(this.exam.questions, q => ({
              id: q.id,
              choice: q.student_answer
            })),
          )
          .then(data => {
            this.exam = data;
            this.processing = false;
          })
          .catch(e => {
            error(e.message);
            this.processing = false;
          });
      }
    },

    setCountDown() {
      clearInterval(this.countDownInterval);
      const interval = 1000;
      let duration = moment.duration(
        (this.exam.end_time - this.exam.current_time) * 1000,
        'milliseconds',
      );

      this.countDownInterval = setInterval(() => {
        duration = moment.duration(duration - interval, 'milliseconds');

        this.countDown = moment({
          hour: duration.hours(),
          minutes: duration.minutes(),
          seconds: duration.seconds()
        }).format('HH:mm:ss');

        if (duration < 0) {
          clearInterval(this.countDownInterval);
          this.countDown = this.$t('exam.time-ended');
          this.complete();
        }
      }, interval);
    }
  }
};
</script>
